module.exports = __webpack_public_path__ + "img/mgline1.8ed18bd2.png";